export const DEFAULT_FOOTER_VISUAL_SPACING = 16;

export const getFooterBottomPadding = (
  platform: string,
  bottomInset: number,
  visualSpacing = DEFAULT_FOOTER_VISUAL_SPACING
) => {
  const safeBottomInset = Math.max(0, bottomInset);

  if (platform === "android") {
    return safeBottomInset + visualSpacing;
  }

  if (platform === "ios") {
    return Math.max(safeBottomInset, visualSpacing);
  }

  return visualSpacing;
};
